import React, { useState } from "react";
import cn from "classnames";
import styles from "./SignCode.module.sass";
import Card from "../Card";
import Icon from "../Icon";
import ModalCode from "../ModalCode";

const SignCode = ({ className, session }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleShowCode = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
    <Card
      className={cn(className)}
      title="Pointage par code"
      classTitle="title-yellow"
    >
      <div className={styles.item}>
        <div className={styles.icon} style={{ backgroundColor: "#000000" }}>
          <Icon name="activity" size="24" fill="#FFFFFF" />
        </div>
        <div className={styles.content}>
          <h3>Pointage par code</h3>
          <p>Code de session : <strong>{session?.code || "Non défini"}</strong></p>
          <p>Les étudiants peuvent pointer leur présence en saisissant ce code à 4 chiffres.</p>
        </div>
      </div>
      <button className={styles.button} onClick={handleShowCode}>
        Afficher le code
      </button>
    </Card>

      <ModalCode
        visible={isModalVisible}
        onClose={handleCloseModal}
        session={session}
      />
    </>
  );
};

export default SignCode;
